import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(1465.103 -4147)">
      <path
        d="M175.647.75a15,15,0,1,1-15,15,15,15,0,0,1,15-15"
        transform="translate(-1625 4147)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M190.407,13.148a14.986,14.986,0,0,0-14.76-12.4v15l-5.126,14.082a14.944,14.944,0,0,0,19.886-16.685"
        transform="translate(-1625 4147)"
        fill={color}
      />
    </g>
  </svg>
);
